import React, { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Typography } from '@mui/material';
import { BasicLayout } from '@monorepo/common';
import { useStyles } from '../styles';
import { ModalBody } from './ModalBody';

interface ICopyOptionsProps {
  guid?: string | null;
  title?: string | null;
  copyJob: () => void;
  isLoading?: boolean;
  hasUnsavedChanges?: boolean;
}
export const CopyOptions = ({ guid, title, copyJob, isLoading, hasUnsavedChanges }:ICopyOptionsProps) => {
  const [isModal, setIsModal] = useState<boolean>(false);
  const classes = useStyles();
  const showModal = () => {
    setIsModal(true);
  };
  const closeModal = () => {
    if (!isLoading) {
      setIsModal(false);
    }
  };

  if (!guid || !title) {
    return null;
  }

  return (
    <BasicLayout
      breadcrumbs={null}
      modalWindowOptions={{
        show: isModal,
        title: `Copy Job Listing: ${title}`,
        closeModal,
        modalBody: <ModalBody
          isLoading={isLoading}
          hasUnsavedChanges={hasUnsavedChanges}
          copyJob={copyJob}
        />
      }}
    >
      <div className={classes.head_item_wrapper}>
        <div className={classes.inner_wrapper_content}>
          <Typography
            variant="subtitle1"
            textAlign="center"
            fontWeight={700}
          >
            Copy this Listing
          </Typography>

          <Typography
            className={classes.comment}
            textAlign="center"
          >
            Use this job as a template for another post.
          </Typography>

          <div className={classes.btn_wrapper_copy}>
            <Button
              variant="contained"
              size="large"
              startIcon={<ContentCopyIcon />}
              onClick={showModal}
              sx={{
                minHeight: 48,
                minWidth: 220,
                whiteSpace: 'nowrap',
              }}
            >
              Copy This Job
            </Button>
          </div>
        </div>
      </div>
    </BasicLayout>
  );
};
